// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-costs-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0 1.5rem;
}

.cost-sections,
.cost-section,
.scheduled-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cost-section h4,
.scheduled-section h4 {
  margin: 0;
  color: var(--tj-primary-gray-800);
}

.cost-section-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cost-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.85rem 1.15rem 1.15rem;
  border: 1px solid #e5e8ec;
  border-radius: 8px;
  background: #fafbfc;
}

.cost-group h5 {
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e8ec;
  color: var(--tj-primary-gray-800);
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.price-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
}

.price-field {
  width: 9rem;
}

.price-field,
.scheduled-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.price-field label,
.scheduled-field label {
  color: var(--tj-primary-gray-700);
  font-size: 0.85rem;
}

.scheduled-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.scheduled-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.scheduled-row {
  padding: 0.85rem 1.15rem 1.15rem;
  border: 1px solid #e5e8ec;
  border-radius: 8px;
  background: #fafbfc;
}

.scheduled-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1.25rem;
}

.scheduled-delete {
  align-self: flex-end;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/company/company-edit/company-costs-form/company-costs-form.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AACJ;;AAEA;;;EAGI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AAEA;;EAEI,SAAA;EACA,iCAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;EACA,sBAAA;EACA,gCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,oBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;;EAEI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;;EAEI,iCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;AACA,whHAAwhH","sourcesContent":[".company-costs-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem 0 1.5rem;\n}\n\n.cost-sections,\n.cost-section,\n.scheduled-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.cost-section h4,\n.scheduled-section h4 {\n    margin: 0;\n    color: var(--tj-primary-gray-800);\n}\n\n.cost-section-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.cost-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 0.85rem 1.15rem 1.15rem;\n    border: 1px solid #e5e8ec;\n    border-radius: 8px;\n    background: #fafbfc;\n}\n\n.cost-group h5 {\n    margin: 0;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #e5e8ec;\n    color: var(--tj-primary-gray-800);\n    font-size: 0.85rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.price-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem 1.25rem;\n}\n\n.price-field {\n    width: 9rem;\n}\n\n.price-field,\n.scheduled-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.price-field label,\n.scheduled-field label {\n    color: var(--tj-primary-gray-700);\n    font-size: 0.85rem;\n}\n\n.scheduled-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n.scheduled-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.scheduled-row {\n    padding: 0.85rem 1.15rem 1.15rem;\n    border: 1px solid #e5e8ec;\n    border-radius: 8px;\n    background: #fafbfc;\n}\n\n.scheduled-fields {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 0.75rem 1.25rem;\n}\n\n.scheduled-delete {\n    align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
